import api from './api';

export const orderService = {
  createOrder: async (orderData) => {
    const response = await api.post('/orders', orderData);
    return response.data;
  },

  getAllOrders: async () => {
    const response = await api.get('/orders');
    return response.data;
  },

  getOrder: async (id) => {
    const response = await api.get(`/orders/${id}`);
    return response.data;
  },

  updateOrderStatus: async (id, statusData) => {
    const response = await api.put(`/orders/${id}`, statusData);
    return response.data;
  },

  getUserOrders: async () => {
    const response = await api.get('/orders/myorders');
    return response.data;
  },

  // Return methods
  requestReturn: async (id, reason) => {
    const response = await api.post(`/orders/${id}/return`, { reason });
    return response.data;
  },

  processReturn: async (id, action) => {
    const response = await api.put(`/orders/${id}/return`, { action });
    return response.data;
  }
};
